export default {
  // 工单补充资料
  supplyMaterial: '/gateway/cs/ticket/supplyMaterial'
}
